// extracted by mini-css-extract-plugin
module.exports = {"body":"lineGraph_body__1QZyi","heading":"lineGraph_heading__3XWsm","desc":"lineGraph_desc__ryx0t"};